import React, { useState } from 'react';
import { Send } from 'lucide-react';

const Newsletter: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Subscribing email:', email);
    setSubmitted(true);
    setEmail('');
    setTimeout(() => {
      setSubmitted(false);
    }, 3000);
  };
  
  return (
    <section className="py-20 bg-blue-600 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Stay Updated with Parking Availability
          </h2>
          <p className="text-lg text-blue-100 mb-8">
            Subscribe to receive real-time updates about parking availability and special offers.
          </p>
          
          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex items-center">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 py-3 px-4 rounded-l-md text-gray-900 focus:outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button
                type="submit"
                className="bg-gray-900 hover:bg-gray-800 py-3 px-6 rounded-r-md flex items-center transition-colors duration-200"
                disabled={submitted}
              >
                {submitted ? (
                  'Subscribed!'
                ) : (
                  <>
                    <span>Subscribe</span>
                    <Send className="h-4 w-4 ml-2" />
                  </>
                )}
              </button>
            </div>
          </form>
          
          <p className="mt-4 text-sm text-blue-200">
            Get notifications about spot availability and pricing updates.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;